/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Import_Success_ToastInputs */

const en_shortcut_keys_import_success_toast = /** @type {(inputs: Shortcut_Keys_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shortcuts imported successfully`)
};

const fr_shortcut_keys_import_success_toast = /** @type {(inputs: Shortcut_Keys_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raccourcis importes avec succes`)
};

const de_shortcut_keys_import_success_toast = /** @type {(inputs: Shortcut_Keys_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpfungen erfolgreich importiert`)
};

const it_shortcut_keys_import_success_toast = /** @type {(inputs: Shortcut_Keys_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collegamenti importati correttamente`)
};

const ru_shortcut_keys_import_success_toast = /** @type {(inputs: Shortcut_Keys_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ярлыки успешно импортированы.`)
};

const es_shortcut_keys_import_success_toast = /** @type {(inputs: Shortcut_Keys_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesos directos importados correctamente`)
};

const zh_cn2_shortcut_keys_import_success_toast = /** @type {(inputs: Shortcut_Keys_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快捷方式已成功导入`)
};

const ja_shortcut_keys_import_success_toast = /** @type {(inputs: Shortcut_Keys_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショートカットが正常にインポートされました`)
};

const hi_shortcut_keys_import_success_toast = /** @type {(inputs: Shortcut_Keys_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉर्टकट सफलतापूर्वक आयात हो गए।`)
};

const pt_pt2_shortcut_keys_import_success_toast = /** @type {(inputs: Shortcut_Keys_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atalhos importados com sucesso`)
};

/**
* | output |
* | --- |
* | "Shortcuts imported successfully" |
*
* @param {Shortcut_Keys_Import_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_import_success_toast = /** @type {((inputs?: Shortcut_Keys_Import_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Import_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_import_success_toast(inputs)
	if (locale === "de") return de_shortcut_keys_import_success_toast(inputs)
	if (locale === "it") return it_shortcut_keys_import_success_toast(inputs)
	if (locale === "ru") return ru_shortcut_keys_import_success_toast(inputs)
	if (locale === "es") return es_shortcut_keys_import_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_import_success_toast(inputs)
	if (locale === "ja") return ja_shortcut_keys_import_success_toast(inputs)
	if (locale === "hi") return hi_shortcut_keys_import_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_import_success_toast(inputs)
	return en_shortcut_keys_import_success_toast(inputs)
});